import React, { useState } from "react";
// import service
import { pinGenerate } from "../services/admin.service";
// import lib
import toastAlert from '../lib/toastAlert';

const GeneratePin = ({ showModal, setShowModal, fetchData }) => {

    const [pinCount, setPinCount] = useState(1);
    const [loader, setLoader] = useState(false);

    const handleSubmit = async () => {
        try {
            if (pinCount < 1) {
                alert('Please enter a valid pin count (minimum 1)');
                return;
            }

            if (pinCount > 50) {
                alert('Please enter a valid pin count (maximum 50)');
                return;
            }

            setLoader(true);
            const { status, message } = await pinGenerate({ pinCount });
            setLoader(false);
            if (status === true) {
                setPinCount(1)
                toastAlert('success', message, 'pinGenerate')
                setShowModal(false);
                fetchData();
            } else if (message) {
                toastAlert('error', message, 'pinGenerate')
            }
        } catch (error) {
            console.error('Error generating pins:', error);
            setLoader(false);
        }
    };

    if (!showModal) return null
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">Generate Pin</h2>
                    <button
                        onClick={() => {
                            setShowModal(false);
                            setPinCount(1)
                        }}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Pin Count
                        </label>
                        <input
                            type="number"
                            min="1"
                            max="50"
                            value={pinCount}
                            onChange={(e) => setPinCount(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="Enter number of pins to generate"
                        />
                        <p className="text-xs text-gray-500 mt-2">
                            Enter the number of pins you want to generate (1-50)
                        </p>
                    </div>

                    <div className="flex gap-3 pt-4">
                        <button
                            onClick={() => {
                                setShowModal(false);
                                setPinCount(1)
                            }}
                            className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-all"
                            disabled={loader}
                        >
                            Close
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={loader || pinCount < 1 || pinCount > 50}
                            className="flex-1 px-4 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg font-semibold hover:from-cyan-600 hover:to-blue-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        >
                            {loader ? (
                                <>
                                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                    Generating...
                                </>
                            ) : (
                                'Generate Pin'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GeneratePin;